import { render, staticRenderFns } from "./QuickSupportCommandsList.vue?vue&type=template&id=490e078c&"
import script from "./QuickSupportCommandsList.vue?vue&type=script&lang=js&"
export * from "./QuickSupportCommandsList.vue?vue&type=script&lang=js&"
import style0 from "./QuickSupportCommandsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports